import { combineReducers } from 'redux';


const initialState = {
    galleryItems:[],
    galleryCount: 0,
    gal_type:'',
    itemIndex:0,
    galleryCreated : false,
    viewMode: "grid",
    tracked:false,
    vignetsCount:0,
    gallerydeleted: false


};

const galleryData = (state = initialState,  action) => {
    var _newState;
    switch(action.type){
        case "FETCH_GALLERY_DATA":
            //return action.galleryList.data.response;
            return state
        case "GALLERY_DATA_SUCCESS":
            //return action.galleryList.data.response;
            return {
                ...state,
                galleryItems  : (action.galleryList && action.galleryList.data)? (action.galleryList.data.response) : [],
                galleryCount  : (action.galleryList && action.galleryList.data && action.galleryList.data.response) ? action.galleryList.data.response.length : state.galleryCount,
                galleryCreated : !state.galleryCreated
            }
        case "GALLERY_DATA_SEARCH_SUCCESS":
            return {
                ...state,
                filteredData : action.filteredData ? action.filteredData:state.filteredData,
                galleryListCount :  action.filteredData ? action.filteredData.length :state.userListCount,
                searchText : action.searchText?action.searchText:'',
                userid : action.userid?'1':'',
                sort : action.sort?action.sort : 'new'

            }
        case "LOAD_MORE_GALLERY_DATA":
            _newState = {...state};
            _newState['galleryItems'] = _newState.galleryItems.concat((action.galleryList && action.galleryList.data) ? action.galleryList.data.response:[]);
            _newState['galleryCount'] = _newState.galleryItems.length;
            return _newState;
            break;
        case "GALLERY_DATA_FROM_STORE":
            return state.galleryItems
        default:
            return state;
    }
}



const galleryUpdate = (state = initialState,  action) => {
    switch(action.type){

        case "SET_TYPE":
            return {
                ...state,
                gal_type  : action.gal_type.type
            }
        case "GET_TYPE":
            return {
                ...state,
                gal_type : state.gal_type
            }
        case "SET_ITEM_ID":
            return {
                ...state,
                itemIndex  : action.gal_item.index
            }
        case "GET_ITEM_ID":
            return {
                ...state,
                itemIndex : state.itemIndex?state.itemIndex:0
            }
        case "SAVE_GALLERY":
            return {
                ...state,
                galleryCreated  : !state.galleryCreated
            }
        case "DOWNLOAD_FILE":
            return {
                ...state,
                fileContent : (action.downloaded && action.downloaded.data)? (action.downloaded.data.response) : state.fileContent,
            }
        case "TRACK_DOWNLOAD":
            return {
                ...state,
                tracked  : !state.galleryCreated
            }
        case "SELECT_VIEWMODE":
            return {
                ...state,
                viewMode : action.state ,
            }
        case "DELETE_FILE":
            return {
                ...state,
                deleted  : !state.gallerydeleted
    }
        case "GALLERY_DET":
            return {
                ...state,
                vignetsCount : (action.countVGallery.data.response.count? action.countVGallery.data.response.count : '') ,
            }
        default:
            return state;
    }
}


const gallery = combineReducers({
    galleryData,
    galleryUpdate
})

export default gallery;
//export const getGalleryData = state => state.gallery.galleryData;

//export const setGalleryUpdate = state => state.gallery.galleryUpdate;



// WEBPACK FOOTER //
// ./src/reducers/gallery.js